import { render } from "./Reporting.vue?vue&type=template&id=cda00d80"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/chatbot_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__